import React, { useState } from "react";
import { DIALS, DIAL_MOMENTS } from "./data.js";

export default function DialCheckStage({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [correctCount, setCorrectCount] = useState(0);
  const [picked, setPicked] = useState(null);

  const current = DIAL_MOMENTS[index];
  const done = index >= DIAL_MOMENTS.length;

  const choose = (dialId) => {
    if (picked) return;
    const correct = dialId === current.correct;
    if (correct) setCorrectCount((c) => c + 1);
    setPicked(dialId);
  };

  const advance = () => {
    setPicked(null);
    setIndex((i) => i + 1);
  };

  if (done) {
    return (
      <div className="animate-popIn text-center">
        <p className="label-pixel mb-2 text-cyan">Dial Check Complete</p>
        <h2 className="pixel-heading mb-4 text-base text-mist">Five Dials, Tuned</h2>

        <div className="mx-auto mb-6 max-w-sm space-y-2 border-2 border-black bg-ink p-4 text-left text-sm">
          <div className="flex justify-between">
            <span className="text-mist/60">Correct Reads</span>
            <span className="text-cyan">
              {correctCount}/{DIAL_MOMENTS.length}
            </span>
          </div>
        </div>

        <p className="mx-auto mb-6 max-w-sm text-xs text-mist/60">
          Same five dials, every time: Rate, Volume, Pitch, Tonality, and the Pause. Naturals
          aren't born knowing which one to turn — they've just practiced noticing which one the
          moment is asking for.
        </p>

        <button onClick={() => onComplete({ correctCount })} className="btn-magenta">
          BUILD YOUR FUNNEL ▶
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/60">
        <span>DIAL CHECK</span>
        <span>
          {index}/{DIAL_MOMENTS.length}
        </span>
      </div>

      <p className="mb-5 text-xs text-mist/60">
        Read the moment. Which dial actually fixes it?
      </p>

      <div
        key={current.id}
        className={`mb-5 border-2 bg-ink p-6 text-center transition-colors ${
          picked ? (picked === current.correct ? "border-lime shadow-glow-cyan" : "border-danger") : "border-black"
        }`}
      >
        <p className="text-sm leading-relaxed text-mist/80">{current.text}</p>
      </div>

      {!picked ? (
        <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
          {DIALS.map((dial) => (
            <button
              key={dial.id}
              onClick={() => choose(dial.id)}
              className="flex flex-col items-center gap-1 border-2 border-mist/30 px-3 py-4 font-display text-[8px] uppercase text-mist transition-colors hover:border-cyan hover:text-cyan"
            >
              <span className="text-lg">{dial.icon}</span>
              {dial.label}
            </button>
          ))}
        </div>
      ) : (
        <div
          className={`animate-popIn border-2 p-4 text-center ${
            picked === current.correct ? "border-lime bg-lime/10 text-lime" : "border-danger bg-danger/10 text-danger"
          }`}
        >
          <p className="mb-1 font-display text-[9px] uppercase">
            {picked === current.correct ? "Right Dial" : `Not Quite — It Was ${DIALS.find((d) => d.id === current.correct)?.label}`}
          </p>
          <p className="mb-3 text-xs text-mist/80">{current.explain}</p>
          <button onClick={advance} className="btn-cyan !text-[9px]">
            CONTINUE ▶
          </button>
        </div>
      )}
    </div>
  );
}
